export const LISTING_PORTALS_ERROR_NOTIFICATION_ID = 'listingFormPortalsError'
